import React, { useCallback, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Slider from 'react-slick';
import img2 from '../Assets/1.jpg';
import img10 from '../Assets/10.jpg';
import img11 from '../Assets/11.jpg';
import img12 from '../Assets/12.jpg';
import img3 from '../Assets/2.jpg';
import img1 from '../Assets/3.png';
import img4 from '../Assets/4.jpeg';
import img5 from '../Assets/5.jpg';
import img6 from '../Assets/6.jpg';
import img7 from '../Assets/7.jpg';
import img8 from '../Assets/8.jpg';
import img9 from '../Assets/9.png';

import formations from '../formations';

const CustomPrevArrow = ({ onClick }) => {
	const { hash } = useLocation();

	const scrollToElement = useCallback(() => {
		if (hash) {
			const target = document.querySelector(hash);
			if (target) {
				const yOffset = -100; // Negative offset
				const yPosition =
					target.getBoundingClientRect().top +
					window.pageYOffset +
					yOffset;
				window.scrollTo({ top: yPosition, behavior: 'smooth' });
			}
		}
	}, [hash]);

	useEffect(() => {
		// Slight delay to ensure DOM is fully rendered
		const timer = setTimeout(scrollToElement, 100);
		return () => clearTimeout(timer);
	}, [hash, scrollToElement]);

	return (
		<div
			onClick={onClick}
			style={{
				position: 'absolute',
				top: '50%',
				left: '0px',
				transform: 'translateY(-50%)',
				zIndex: 1,
				backgroundColor: '#87152B',
				borderRadius: '50%',
				padding: '10px',
				cursor: 'pointer',
				boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
			}}
		>
			<svg
				xmlns='http://www.w3.org/2000/svg'
				style={{ height: '20px', width: '20px', color: 'white' }}
				fill='none'
				viewBox='0 0 24 24'
				stroke='currentColor'
				strokeWidth={2}
			>
				<path
					strokeLinecap='round'
					strokeLinejoin='round'
					d='M15 19l-7-7 7-7'
				/>
			</svg>
		</div>
	);
};

const CustomNextArrow = ({ onClick }) => {
	return (
		<div
			onClick={onClick}
			style={{
				position: 'absolute',
				top: '50%',
				right: '0px',
				transform: 'translateY(-50%)',
				zIndex: 1,
				backgroundColor: '#87152B',
				borderRadius: '50%',
				padding: '10px',
				cursor: 'pointer',
				boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
			}}
		>
			<svg
				xmlns='http://www.w3.org/2000/svg'
				style={{ height: '20px', width: '20px', color: 'white' }}
				fill='none'
				viewBox='0 0 24 24'
				stroke='currentColor'
				strokeWidth={2}
			>
				<path
					strokeLinecap='round'
					strokeLinejoin='round'
					d='M9 5l7 7-7 7'
				/>
			</svg>
		</div>
	);
};

const FormationCarousel = () => {
	const settings = {
		dots: false,
		infinite: true,
		autoplay: true,
		speed: 500,
		autoplaySpeed: 2000,
		cssEase: 'linear',
		slidesToShow: 4,
		slidesToScroll: 1,
		nextArrow: <CustomNextArrow />,
		prevArrow: <CustomPrevArrow />,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 2
				}
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1
				}
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 1
				}
			}
		]
	};
	const slideimgs = [
		{ id: 1, img: img1 },
		{ id: 2, img: img2 },
		{ id: 3, img: img3 },
		{ id: 4, img: img4 },
		{ id: 5, img: img5 },
		{ id: 6, img: img6 },
		{ id: 7, img: img7 },
		{ id: 8, img: img8 },
		{ id: 9, img: img9 },
		{ id: 10, img: img10 },
		{ id: 11, img: img11 },
		{ id: 12, img: img12 }
	];
	const navigate = useNavigate();
	const handleFormationClick = (formation) => {
		// Navigate to the specific formation page
		navigate(`/formation/${formation.id}`);
	};

	return (
		<div className='flex items-center justify-center w-full'>
			<div className=' w-full md:w-[80%] h-[500px] flex items-center justify-center bg-white '>
				<div className='w-[90%] bg-white p-4 rounded-xl shadow border border-gray-100'>
					{/* Titre <h2> optimisé pour le SEO avec mots-clés ciblés */}
					<h2 className='text-lg text-[#87152B] text-left font-semibold border-b-[#87152B] border-b-2 uppercase'>
						NOS FORMATIONS EN HABILITATION ÉLECTRIQUE & SÉCURITÉ AU TRAVAIL
					</h2>

					<Slider {...settings}>
						{formations.map((ref, index) => (
							<div
								key={ref.id}
								className='slide-containerf rounded-xl cursor-pointer'
								onClick={() => handleFormationClick(ref)}
							>
								<div className='h-full w-full flex flex-col items-center justify-start '>
									<div className='w-full h-16 bg-[#87152B] text-base flex flex-col items-center justify-center py-2 px-4'>
										<p className='w-[90%] h-full text-center flex flex-row items-center text-xs sm:text-xs md:text-xs justify-center my-2 mx-4 text-white'>
											{ref.title}
										</p>
									</div>
									<div className='w-full h-full'>
										<img
											src={slideimgs[index].img}
											alt={`Formation CFCAE - ${ref.title}`}
											className='w-full h-full'
										/>
									</div>
								</div>
							</div>
						))}
					</Slider>
				</div>
			</div>
		</div>
	);
};

export default FormationCarousel;